import { FC } from 'react'
import { Button } from 'entities/Button'
import { useQrCodeStore } from 'shared/store/qrCodeSlice'
import { useConfigStore } from 'shared/store/configSlice'
import { useGlobalStore } from 'shared/store/globalSlice'
import { usePDFExport } from 'shared/hooks/usePDFExport'
import { getAppName } from 'shared/helpers/getAppName'
import { RenderIf } from 'shared/helpers/renderIf'
import { DefaultLayout } from './DefaultLayout'
import { PDFContainer_Outer, PDFContainer } from './styled'
import { SpecialLayout } from './SpecialLayout'

export const PdfGenerator: FC = () => {
  const isCC = useGlobalStore().isCCSelected
  const { selectedCaption } = useQrCodeStore()
  const config = useConfigStore().config?.menuConfig
  const interfaceConfig = useConfigStore().config?.interfaceConfig

  const { ref, exportPDF } = usePDFExport({ pdfFormat: 'a6' })

  const savePdf = async () => {
    await fetch(interfaceConfig?.[getAppName(isCC)]?.backgroundImage || '', {
      method: 'GET',
      headers: {
        'Cache-Control': 'no-cache'
      }
    })
    await fetch(interfaceConfig?.[getAppName(isCC)]?.logoImage || '', {
      method: 'GET',
      headers: {
        'Cache-Control': 'no-cache'
      }
    })
    exportPDF(`tisch_${selectedCaption}`)
  }

  const isLayoutDefault = () => {
    return (
      config?.[getAppName(isCC)]?.paymentVariant !== 1 ||
      config?.[getAppName(isCC)]?.bookingVariant !== 2
    )
  }

  return (
    <>
      <PDFContainer_Outer>
        <Button handleClick={savePdf} width='105mm'>
          Download
        </Button>
        <PDFContainer
          ref={ref}
          style={{
            backgroundImage: `url(${interfaceConfig?.[getAppName(isCC)]?.backgroundImage})`
          }}
        >
          <RenderIf condition={isLayoutDefault()}>
            <DefaultLayout />
          </RenderIf>
          <RenderIf condition={!isLayoutDefault()}>
            <SpecialLayout />
          </RenderIf>
        </PDFContainer>
      </PDFContainer_Outer>
    </>
  )
}
